import { ref } from 'vue';
import {
  deleteBotFilterApiRequest,
  getBotFilterApiRequest,
  getBotFiltersApiRequest,
  postCreateBotFilterApiRequest,
  putUpdateBotFilterApiRequest,
} from '@/services/api/bot-filter-api';
import { putUserApiRequest } from '@/services/api/user-api';

export type BotFilterRuleRow = {
  id: string;
  name: string;
  rules: Record<string, unknown>;
  rulesUsed: unknown[];
};

export const normalizeBotFilterRules = (payload: unknown): BotFilterRuleRow[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload && typeof payload === 'object') {
    return Object.values(payload) as BotFilterRuleRow[];
  }
  return [];
};

export const botFilterRules = ref<BotFilterRuleRow[]>([]);

export class BotFiltersApi {
  loading: boolean = false;
  error: boolean = false;

  data: any = {};
  dataFilter: any = {};

  get() {
    this.loading = true;
    return getBotFiltersApiRequest().then((payload: unknown) => {
      const rules = normalizeBotFilterRules(payload);
      this.data = rules;
      botFilterRules.value = rules;
      this.loading = false;
      return rules;
    });
  }

  getById(id: string) {
    this.loading = true;
    return getBotFilterApiRequest(id).then((payload: unknown) => {
      this.dataFilter = payload;
      this.loading = false;
      return payload;
    });
  }

  putRules(id: string, payload: object) {
    return putUpdateBotFilterApiRequest(id, payload).then((res) => {
      this.loading = false;
      return res;
    });
  }

  put(payload: object) {
    return putUserApiRequest(payload as Partial<Bemob.User>).then((res) => {
      this.loading = false;
      return Promise.resolve(res);
    });
  }

  post(data: object) {
    this.loading = true;
    return postCreateBotFilterApiRequest(data).then((response) => {
      this.loading = false;
      return response;
    });
  }

  delete(id: string) {
    return deleteBotFilterApiRequest(id).then(() => {});
  }
}

export default new BotFiltersApi();
